import { Ng2StateDeclaration } from '@uirouter/angular';
import { SendPurchasesContainerComponent } from './send-purchases-container/send-purchases-container.component';

export const QuickbooksSendPurchasesRoute: Ng2StateDeclaration = {
    // name: 'quickbooks.**'
    name: 'qbsendexpenses',
    url: '/qbsendexpenses',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.IndirectRateModule)
    data: { requiresAuth: true },
    component: SendPurchasesContainerComponent
};
